export const FILTER_NAME = 'bundle'
